import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChildren,
  AfterContentInit,
  OnDestroy
} from '@angular/core';
import { Observable, Observer, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { CommonService } from '../../services/common.service';
import { Application } from '../../../../enums/application.enums';
import { APIENDPOINT } from '../../../../core/api-url.enum';
import { AuthService } from '../../../../core/auth.service';
import { BlockedUserStatus } from '../../pipes/blocked-users.pipe';
import { ApiCallService } from '../../../../services/api-call.service';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-search-bar-typeahead',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
  host: { class: 'search-layout' },
  providers: [BlockedUserStatus]
})
export class SearchBarComponent
  implements OnInit, AfterContentInit, OnChanges, OnDestroy
{
  @Input() userBlockList = [];
  @Output() listselected = new EventEmitter();
  searchObj = { text: '' };
  suggestions$: Observable<any>;
  errorMessage: string;
  currSelectedItem;
  @Output() closeSearchBar: EventEmitter<any> = new EventEmitter();
  @ViewChildren('search') search;
  isLoaded = false;

  constructor(
    private readonly router: Router,
    public readonly cs: CommonService,
    public readonly authService: AuthService,
    private readonly blockedUsers: BlockedUserStatus,
    private readonly apiCallService: ApiCallService,
    private readonly dataService: DataService
  ) {}

  ngOnInit(): void {
      if (!this.searchObj.text) {
        this.cs.hashtagSearch.subscribe((res) => {
          if (res) {
            this.searchObj.text = res;
          }
        });
      }
      this.cs.setSearchReset(false);
      this.isFormReset();
      this.suggestions$ = new Observable((observer: Observer<string>) => {
        observer.next(this.searchObj.text);
      }).pipe(
        debounceTime(800),
        distinctUntilChanged(),
        switchMap((query: string) => {
          if (query && query.trim().length > Number(Application.ZERO)) {
            const filteredQuery = query.replace(/#/g, '');
            return this.apiCallService
              .get(
                APIENDPOINT.searchUserAndHashtag(
                  filteredQuery,
                  Application.FIFTY
                ),
                false
              )
              .pipe(
                map((res: any) => {
                  let itemList: any = [];
                  if (res && res.status) {
                    if (res.data.length) {
                      itemList = [];
                      const resItems = res.data.filter(
                        (el) => !this.blockedUsers.transform(el.email)
                      );
                      resItems.forEach((ele: any) => {
                        if (ele.is_taxonomy) {
                          itemList.push({
                            ...ele,
                            fullName: `${ele.name}`,
                            firstName: `${ele.name}`,
                            type: 'data',
                            dataType: `creator_category`,
                            label: 'Search Results'
                          });
                        } else {
                          if (
                            this.userBlockList.indexOf(ele.email) ===
                            Application.MINUS_ONE
                          ) {
                            itemList.push({
                              ...ele,
                              fullName:
                                ele.pk === 'HASHTAG'
                                  ? `${ele.name}`
                                  : `${ele.first_name} ${ele.last_name}`,
                              firstName:
                                ele.pk === 'HASHTAG'
                                  ? `${ele.name}`
                                  : `${ele.first_name}`,
                              type: 'data',
                              dataType:
                                ele.pk === 'HASHTAG' ? `hashtag` : `creators`,
                              label: 'Search Results'
                            });
                          }
                        }
                      });
                    } else {
                      itemList = [];
                      itemList.push({
                        fullName: '',
                        type: 'data',
                        label: 'No Results Found'
                      });
                    }
                  } else {
                    itemList = [];
                  }
                  return itemList;
                }),
                tap({
                  error: (err: any) => {
                    this.cs.showErrorMessage(
                      this.cs.getErrorText(err, 'message')
                    );
                  }
                })
              );
          }
          return of([]);
        })
      );
  }

  ngAfterContentInit(): void {
    this.isLoaded = true;
    this.cs.isFocussed.subscribe((res) => {
      if (res) {
        setTimeout(() => {
          this.search.first.nativeElement.focus();
          this.cs.scrollToTop();
        }, Application.ONE_HUNDRED);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes &&
      changes.userBlockList &&
      changes.userBlockList.currentValue
    ) {
      this.userBlockList = changes.userBlockList.currentValue;
    }
  }

  selectOption(evt): void {
      this.listselected.next(true);
      let url;
      if (evt.item?.is_taxonomy) {
        this.dataService.setCreatorCategoryData(evt.item);
        url = `global/category-creator-listing`;
      } else if (evt.item.dataType === 'creators') {
        url = `${evt.item?.user_name}`;
        if (this.authService.isAuthenticated()) {
          url = `${evt.item?.user_name}`;
        }
      } else if (!!evt.item.dataType) {
        const type = evt.item.dataType;
        const st = evt.value;
        url = `search-result/${type}/${st}`;
        if (this.authService.isAuthenticated()) {
          url = `dashboard/search-result/${type}/${st}`;
        }
      }
      url && this.navigateToUser(url);
  }

  navigateToUser(url) {
    this.router.navigate([url]);
  }

  isFormReset() {
    this.cs.isResetSearch.subscribe((res) => {
      if (res) {
        this.searchObj.text = '';
      }
    });
  }

  clearSearch() {
    this.searchObj.text = '';
    this.search.first.nativeElement.focus();
  }

  ngOnDestroy(): void {
    this.cs.hashtagSearch.next('');
    this.searchObj.text = '';
  }
}
